// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tablecellforemployeeRoster {
    font-family: "Inter";
    font-size: 14px;
    font-weight: 700;
    line-height: 17px;
    letter-spacing: 0.02em;
    text-align: left;
    color: #0070E9;
    /* padding:70px */

}

.tablecellforemployeeRoster1 {
    font-family: "Inter";
    font-size: 14px;
    font-weight: 700;
    line-height: 17px;
    letter-spacing: 0.02em;
    text-align: left;
    color: #0070E9;
    /* padding:70px; */
    margin-left: 67px;

}

.EmployeeRoster {
    font-family: "Inter";
    font-size: 18px;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: 0.02em;
    text-align: left;
    color: #0070E9
}

.mainFrame {
    background-color: white;
    height: 600px;
}


.AddEmployerButton {
    width: 156px;
    height: 45px;
    border-radius: 3px;
    font-family: "Inter";
    font-size: 16px;
    font-weight: 700 !important;
    line-height: 19px;
    letter-spacing: 0.02em;
    text-align: center;
    background-color: #FE602F !important;
    color: white !important
}

.jobType {
    font-family: "Inter";
    font-size: 14px;
    font-weight: 700 !important;
    line-height: 17px;
    letter-spacing: 0.02em;
    text-align: left;

}

.holidayDescription{
  white-space: nowrap !important;
  word-wrap: break-word !important;
   text-overflow: ellipsis !important;
   overflow: hidden !important;
   width:150px !important
  
}`, "",{"version":3,"sources":["webpack://./src/views/panel/ConfigurationPage/Configurationpage.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;;AAErB;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,iBAAiB;;AAErB;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB;AACJ;;AAEA;IACI,uBAAuB;IACvB,aAAa;AACjB;;;AAGA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,2BAA2B;IAC3B,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,oCAAoC;IACpC;AACJ;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,2BAA2B;IAC3B,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;;AAEpB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;GAC/B,kCAAkC;GAClC,2BAA2B;GAC3B;;AAEH","sourcesContent":[".tablecellforemployeeRoster {\n    font-family: \"Inter\";\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 17px;\n    letter-spacing: 0.02em;\n    text-align: left;\n    color: #0070E9;\n    /* padding:70px */\n\n}\n\n.tablecellforemployeeRoster1 {\n    font-family: \"Inter\";\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 17px;\n    letter-spacing: 0.02em;\n    text-align: left;\n    color: #0070E9;\n    /* padding:70px; */\n    margin-left: 67px;\n\n}\n\n.EmployeeRoster {\n    font-family: \"Inter\";\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 22px;\n    letter-spacing: 0.02em;\n    text-align: left;\n    color: #0070E9\n}\n\n.mainFrame {\n    background-color: white;\n    height: 600px;\n}\n\n\n.AddEmployerButton {\n    width: 156px;\n    height: 45px;\n    border-radius: 3px;\n    font-family: \"Inter\";\n    font-size: 16px;\n    font-weight: 700 !important;\n    line-height: 19px;\n    letter-spacing: 0.02em;\n    text-align: center;\n    background-color: #FE602F !important;\n    color: white !important\n}\n\n.jobType {\n    font-family: \"Inter\";\n    font-size: 14px;\n    font-weight: 700 !important;\n    line-height: 17px;\n    letter-spacing: 0.02em;\n    text-align: left;\n\n}\n\n.holidayDescription{\n  white-space: nowrap !important;\n  word-wrap: break-word !important;\n   text-overflow: ellipsis !important;\n   overflow: hidden !important;\n   width:150px !important\n  \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
